import * as constants from './constants';
import userRequest, {
    userApi
} from 'common/request';
export const changeCourseInfo = (subject,courseid,title) => ({
    type: constants.CHANGE_LABROOM_DATA,
    subject,
    courseid,
    title
});

export const finishedCouseId = (finishedList) => ({
    type: constants.CHANGE_LABROOM_FINISHEDLIST,
    finishedList
})

 export const getCourseInfo = (course_id) => {
     return (dispatch, getState) => {
         userRequest.get(window.AppConfig.mainIP + userApi.courseDetail, {
             course_id
         }).then((res) => {
             console.log('-----------------getState',getState())
             if (res.code === 0) {
                dispatch(changeCourseInfo(res.data.subject, res.data.id,res.data.title))
                console.log(res, '...........')
                const catche = res
                const userinfo = JSON.parse(localStorage.getItem('userinfo'))
                const search = {usernames: [userinfo.user_name]}
                const params = {
                    isscore: 0,
                    isprogress: 1,
                    search: JSON.stringify(search)
                }
                userRequest.get(`${window.AppConfig.mainIP}${userApi.subjectMembers}/${course_id}`, params)
                .then(res => {
                    // if(getState().toJS().courseproject.info){
                    //     localStorage.setItem('courseInfo', getState().toJS().courseproject.info)
                    // }
                    // const courseprojectInfo = JSON.parse(localStorage.getItem('courseInfo'))
                    const subject = getState().toJS().labroom.subject
                    const subjectMembers = res.data.data
                    courseSubjectHandle(subject, subjectMembers[0].Subject)
                    // console.log('------------------------------------------getState', getState())
                    // console.log('------------------------------------------subjectMembers', subjectMembers)
                    // console.log('------------------------------------------courseprojectInfo', courseprojectInfo)
        
                    dispatch(changeCourseInfo(subject, getState().toJS().labroom.courseid, getState().toJS().labroom.title))
                })
             }
         })
     }
 }

 const courseSubjectHandle = (courseList, learnList) => {
    for (let item of courseList) {
        const learnItem = learnList.find(value => item.id == value.SubId)
        if (learnItem) {
            item.Duration = learnItem.Duration
            item.DurationStr = `${parseInt(learnItem.Duration/60)>9?parseInt(learnItem.Duration/60):'0'+parseInt(learnItem.Duration/60)}:${parseInt(learnItem.Duration%60)>9?parseInt(learnItem.Duration%60):'0'+parseInt(learnItem.Duration%60)}`
            item.LearnTime = learnItem.LearnTime
            item.LearnTimeStr = `${parseInt(learnItem.LearnTime/60)>9?parseInt(learnItem.LearnTime/60):'0'+parseInt(learnItem.LearnTime/60)}:${parseInt(learnItem.LearnTime%60)>9?parseInt(learnItem.LearnTime%60):'0'+parseInt(learnItem.LearnTime%60)}`
        }
        if (item.childs) courseSubjectHandle(item.childs,learnList)
    }
}

// 查看课程章节是否已学过
export const getFinishedCourse = (course_id, user_id) => {
    return (dispatch) => {
        userRequest.get(window.AppConfig.mainIP + userApi.courseListFinished, {
            "type": "learned", "get_sub_list":"1", course_id, user_id
        }).then((res) => {
            if (res.success === true && res.result.data.length > 0) {
                dispatch(finishedCouseId(res.result.data))
            }
        })
    }
}
